module.exports = __webpack_public_path__ + "static/result-of-trial-d7222d9b105068d0090a6fbd18af46a1.png";